import React from 'react';
import { Form } from 'react-bootstrap';

const FormView = ({ 
    children, 
    onSubmit, 
    validated = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <Form 
            onSubmit={onSubmit} 
            validated={validated}
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </Form>
    );
};

export default FormView;

